import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Secondary, SvgIcon } from "@cinch-labs/design-system";
import { useSearchAlertsDrawer } from "../../../hooks";
import SearchAlertsDrawer from "../drawer";
import styles from "./search-alerts-button.module.css";
const SearchAlertsButton = ({ searchLayoutArea ="basket"  })=>{
    const { handleSearchAlertsDrawerClick , showSearchAlertsDrawer , closeSearchAlertsDrawer  } = useSearchAlertsDrawer(searchLayoutArea);
    const buttonStyles = {
        basket: styles.filterBasketSearchAlertButton,
        header: styles.filterHeaderSearchAlertButton,
        listings: styles.filterListingSearchAlertButton,
        noresults: styles.filterListingSearchAlertButton
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Secondary, {
                type: "button",
                classNames: {
                    button: buttonStyles[searchLayoutArea]
                },
                onClick: handleSearchAlertsDrawerClick,
                "data-cy": "search-alerts-cta",
                children: [
                    /*#__PURE__*/ _jsx(SvgIcon, {
                        name: "mail",
                        size: 16,
                        id: "search-alert-icon",
                        className: styles.filterSearchAlertButtonIcon
                    }),
                    "Set up search alert"
                ]
            }),
            showSearchAlertsDrawer && /*#__PURE__*/ _jsx(SearchAlertsDrawer, {
                onClose: closeSearchAlertsDrawer
            })
        ]
    });
};
export default SearchAlertsButton;
